<template>
  <div class="page-wrapper">
        <main-navigation></main-navigation>

    <main class="container py-4">
      <div class="card shadow-lg border-0 rounded-4 p-4">
        <h4 class="mb-4 fw-bold page-title"><i class="bi bi-credit-card"></i> Receive Payment</h4>

        <!-- 🔍 Tenant Search -->
        <div class="mb-4 position-relative">
          <label class="form-label">Search Tenant (Name / ID)</label>
          <input
            v-model="search"
            @input="filterTenants"
            type="text"
            class="form-control"
            placeholder="Type name or ID..."
          />

          <!-- Dropdown -->
          <ul v-if="filteredTenants.length && search" class="dropdown-list">
            <li
              v-for="tenant in filteredTenants"
              :key="tenant.id"
              @click="selectTenant(tenant)"
            >
              {{ tenant.tenant_name }} - {{ tenant.tenant_idnumber }}
            </li>
          </ul>
        </div>

        <!-- Selected Tenant Info -->
        <div v-if="selectedTenant" class="alert alert-info">
          <strong>{{ selectedTenant.tenant_name }}</strong><br />
          ID: {{ selectedTenant.tenant_idnumber }}<br />
          Phone: {{ selectedTenant.tenant_phone }}
        </div>

        <!-- 🚀 FORM -->
        <form @submit.prevent="submitPayment">
          <div class="row g-3">

            <div class="col-md-6">
              <label class="form-label">Amount (KES)</label>
              <input v-model="form.TransAmount" type="number" class="form-control" required />
            </div>

            <div class="col-md-6">
              <label class="form-label">Transaction ID</label>
              <input v-model="form.TransID" type="text" class="form-control" required />
            </div>

            <div class="col-md-6">
              <label class="form-label">First Name</label>
              <input v-model="form.FirstName" type="text" class="form-control" />
            </div>

            <div class="col-md-6">
              <label class="form-label">Business Short Code</label>
              <input v-model="form.BusinessShortCode" type="text" class="form-control" />
            </div>

            <div class="col-md-6">
              <label class="form-label">Payment Reference</label>
              <input v-model="form.payment_reference" type="text" class="form-control" />
            </div>

          </div>

          <!-- Submit -->
          <div class="mt-4 d-flex justify-content-end">
            <button class="btn btn-primary px-4" :disabled="loading || !selectedTenant">
              <span v-if="loading">Processing...</span>
              <span v-else>Submit Payment</span>
            </button>
          </div>
        </form>

        <!-- 📩 Message -->
        <div v-if="message" class="alert mt-4" :class="success ? 'alert-success' : 'alert-danger'">
          {{ message }}
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { apiFetch } from "@/services/api.js";

export default {
  name: "ReceivePayment",

  data() {
    return {
      tenants: [],
      filteredTenants: [],
      search: "",
      selectedTenant: null,

      loading: false,
      message: "",
      success: false,

      form: {
        idnumber: "",
        TransAmount: "",
        TransID: "",
        FirstName: "",
        BusinessShortCode: "",
        payment_reference: "",
      },
    };
  },

  async mounted() {
    this.loadTenants();
  },

  methods: {
    // 🔽 Load tenants
    async loadTenants() {
      try {
        const data = await apiFetch("/tenants");
        this.tenants = data || [];
      } catch (error) {
        console.error("❌ Failed to load tenants", error);
      }
    },

    // 🔍 Filter tenants
    filterTenants() {
      const search = this.search.toLowerCase();

      this.filteredTenants = this.tenants.filter((t) => {
        return (
          (t.tenant_name || "").toLowerCase().includes(search) ||
          (t.tenant_idnumber || "").toLowerCase().includes(search)
        );
      });
    },

    // ✅ Select tenant
    selectTenant(tenant) {
      this.selectedTenant = tenant;
      this.search = `${tenant.tenant_name} (${tenant.tenant_idnumber})`;
      this.filteredTenants = [];

      // Autofill idnumber
      this.form.idnumber = tenant.tenant_idnumber;
    },

    // 🚀 Submit payment
    async submitPayment() {
      this.loading = true;
      this.message = "";

      try {
        const data = await apiFetch("/receive/payments", {
          method: "POST",
          body: JSON.stringify(this.form),
        });

        this.success = true;
        this.message = data.message || "Payment processed successfully";

        // Reset only payment fields (keep selected tenant)
        this.form.TransAmount = "";
        this.form.TransID = "";
        this.form.FirstName = "";
        this.form.BusinessShortCode = "";
        this.form.payment_reference = "";
        this.$router.push('/all/payments');


      } catch (error) {
        this.success = false;
        this.message = error.message || "Failed to process payment";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.page-wrapper {
  background: var(--dash-bg);
  min-height: 100vh;
}

.card {
  max-width: 800px;
  margin: auto;
  border-radius: var(--dash-radius);
  border: 1px solid var(--dash-line);
  box-shadow: var(--dash-shadow-sm);
}

/* Dropdown styling */
.dropdown-list {
  position: absolute;
  width: 100%;
  background: white;
  border: 1px solid var(--dash-line);
  border-radius: var(--dash-radius-sm);
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
  margin-top: 5px;
}

.dropdown-list li {
  padding: 10px;
  cursor: pointer;
  transition: 0.2s;
}

.dropdown-list li:hover {
  background: var(--dash-bg-alt);
}

input {
  border-radius: var(--dash-radius);
}

button {
  border-radius: var(--dash-pill);
}

/* Page title — matches the shared heading treatment in design.css */
.page-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: var(--dash-fs-h1);
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--dash-ink);
}

.page-title i {
  font-size: 1.05em;
  color: var(--dash-primary);
}
</style>